<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14.86 12.04">
    <defs>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <g id="Group_1071" data-name="Group 1071">
          <g id="Group_1070" data-name="Group 1070">
            <path
              id="Path_400"
              data-name="Path 400"
              class="cls-1"
              d="M2.81,2.93H0V0H2.81Z"
            />
            <path
              id="Path_401"
              data-name="Path 401"
              class="cls-1"
              d="M2.81,7.48H0V4.55H2.81Z"
            />
            <path
              id="Path_402"
              data-name="Path 402"
              class="cls-1"
              d="M2.81,12H0V9.11H2.81Z"
            />
            <path
              id="Path_403"
              data-name="Path 403"
              class="cls-1"
              d="M14.86,2.93H4.27V0H14.86Z"
            />
            <path
              id="Path_404"
              data-name="Path 404"
              class="cls-1"
              d="M14.86,7.48H4.27V4.55H14.86Z"
            />
            <path
              id="Path_405"
              data-name="Path 405"
              class="cls-1"
              d="M14.86,12H4.27V9.11H14.86Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
